module.exports = __webpack_public_path__ + "assets/img/right_2.068e31f5.png";